import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';

export const completedTaskIdAtom = atom<string | undefined>(undefined);
export const completedSubtaskIdAtom = atom<string | undefined>(undefined);

export const TASK_NOTIFICATION_DISPLAYED_DATE_TIME_STORAGE_KEY =
  'taskNotificationDisplayedDateTime';

export const taskNotificationDisplayedDateTimeAtom = atomWithStorage<string | null>(
  TASK_NOTIFICATION_DISPLAYED_DATE_TIME_STORAGE_KEY,
  null,
);
